function body_background(id) {
    var dat = id;
    document.body.className = 'fondo_' + dat;
}



